import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { AJAX_URL } from '../../config/index.js';
import { AJAX_NONCE } from '../../config/index.js';

export default function BeefBracketVoteForm({
  isLoading,
  setLoading,
  setView,
  setShowNotice,
  currentVote,
  handleTransitionToContenderScreen
}) {
  const [submittedVote, setSubmittedVote] = useState(null);
  const [validForm, setValidForm] = useState(null);
  const [validateMessage, setValidateMessage] = useState(
    'Please fill out all fields to submit your vote.'
  );

  // Handle form submission
  const submitVoteForm = () => {
    if (!currentVote) {
      return;
    }

    setLoading(true);

    // Add Validation and submission logic here
    // Check fields are filled, send data to server, etc.
    const formData = {
      poll_id: currentVote.poll_id,
      first_name: document.querySelector('input[name="first_name"]').value,
      last_name: document.querySelector('input[name="last_name"]').value,
      email: document.querySelector('input[name="email"]').value,
      vote: currentVote.title,
      nonce: AJAX_NONCE,
      user_agent: navigator.userAgent
    };

    // validate form data
    if (formData.first_name && formData.last_name && formData.email) {
      $.ajax({
        type: 'POST',
        url: `${AJAX_URL}wl_submit_beef_bracket_vote`,
        dataType: 'json',
        encode: true,
        data: formData,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => {
          if (res.success) {
            // Push to dataLayer for analytics
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'beef_bracket_vote',
              event_type: 'vote_submitted',
              vote: currentVote.title,
              timestamp: new Date().toISOString()
            });

            setValidForm(true);
            setSubmittedVote(true);
            setLoading(false);
            setValidateMessage('Your vote has been successfully submitted!');
          } else {
            setValidForm(false);
            setLoading(false);
            setValidateMessage(
              res.data.message ||
                'An error occurred while submitting your vote.'
            );
          }
        })
        .catch((err) => {
          setValidateMessage(
            err.message || 'An error occurred while submitting your vote.'
          );
          setLoading(false);
          setValidForm(false);
        });
    } else {
      setValidForm(false);
      setLoading(false);
      setValidateMessage('All fields are required to submit your vote.');
    }
  };

  return (
    <div className="beef-bracket-vote-form-container">
      <div className="beef-bracket-vote-form-close">
        <span
          className="close-icon"
          onClick={() => {
            setShowNotice(false);
            handleTransitionToContenderScreen();
          }}
        ></span>
      </div>
      <div
        className="beef-bracket-vote-form-image"
        style={{
          backgroundImage: `url(${currentVote ? currentVote.image : ''})`
        }}
      >
        <img
          src={currentVote ? currentVote.image : ''}
          alt={currentVote ? currentVote.title : ''}
        />
      </div>
      <div className="beef-bracket-vote-form-content">
        {validForm && submittedVote ? (
          <>
            <h2>THANK YOU</h2>
            <div className="beef-bracket-vote-title">
              Your Vote Has
              <br />
              Been Submitted
            </div>
            <button
              className="btn btn-block btn-primary btn-submit btn-start-over-tablet"
              onClick={() => {
                setSubmittedVote(null);
                handleTransitionToContenderScreen();
              }}
            >
              Start Over
            </button>
            <a
              href="/beef-bowl-tally"
              className="btn btn-block btn-primary btn-submit btn-start-over"
            >
              Start Over
            </a>
          </>
        ) : (
          <>
            <h2>CAST YOUR VOTE FOR</h2>
            <div className="beef-bracket-vote-title">
              {currentVote ? currentVote.title : ''}
            </div>
            <div className="beef-bracket-vote-form">
              <div className="form__row">
                <div className="form__field">
                  <input
                    type="text"
                    className="form__input"
                    name="first_name"
                    placeholder="First Name"
                  />
                </div>
                <div className="form__field">
                  <input
                    type="text"
                    className="form__input"
                    name="last_name"
                    placeholder="Last Name"
                  />
                </div>
              </div>
              <div className="form__field">
                <input
                  type="text"
                  className="form__input"
                  name="email"
                  placeholder="Your Email"
                />
              </div>
              {validForm == false && submittedVote && (
                <div className="beef-bracket-vote-form-notice">
                  {validateMessage}
                </div>
              )}
              <button
                className="btn btn-block btn-primary btn-submit"
                onClick={() => {
                  setSubmittedVote(currentVote);
                  submitVoteForm();
                }}
              >
                {isLoading ? 'Submitting...' : 'Submit Your Vote'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
